import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { HomeRoutingModule } from './home-routing.module';

import { FashionOneComponent } from './fashion/fashion-one/fashion-one.component';
import { WatchComponent } from './watch/watch.component';


// Widgest Components
import { SliderComponent } from './widgets/slider/slider.component';
import { BlogComponent } from './widgets/blog/blog.component';
import { LogoComponent } from './widgets/logo/logo.component';
import { ServicesComponent } from './widgets/services/services.component';
import { CollectionComponent } from './widgets/collection/collection.component';
import { AndroidComponent } from './servicepage/android/android.component';
import { WebsiteDevelopmentComponent } from './servicepage/website-development/website-development.component';
import { WebDesignComponent } from './servicepage/web-design/web-design.component';
import { EcommerceComponent } from './servicepage/ecommerce/ecommerce.component';
import { CMSComponent } from './servicepage/cms/cms.component';
import { WordPressComponent } from './servicepage/word-press/word-press.component';
import { IOSComponent } from './servicepage/i-os/i-os.component';
import { HybridAppComponent } from './servicepage/hybrid-app/hybrid-app.component';
import { ReactAppComponent } from './servicepage/react-app/react-app.component';
import { MobileAppComponent } from './servicepage/mobile-app/mobile-app.component';
import { EnterpriseComponent } from './servicepage/enterprise/enterprise.component';
import { ProductComponent } from './servicepage/product/product.component';
import { SoftwareMaintenanceComponent } from './servicepage/software-maintenance/software-maintenance.component';
import { UIUXDesignComponent } from './servicepage/ui-uxdesign/ui-uxdesign.component';
import { WireframingComponent } from './servicepage/wireframing/wireframing.component';
import { PrototypingComponent } from './servicepage/prototyping/prototyping.component';
import { UXResearchComponent } from './servicepage/uxresearch/uxresearch.component';
import { ManualTestingComponent } from './servicepage/manual-testing/manual-testing.component';
import { AutomatedComponent } from './servicepage/automated/automated.component';
import { PerformanceComponent } from './servicepage/performance/performance.component';
import { SecurityComponent } from './servicepage/security/security.component';
import { UserAcceptanceComponent } from './servicepage/user-acceptance/user-acceptance.component';
import { BrandingComponent } from './servicepage/branding/branding.component';

@NgModule({
  declarations: [
    FashionOneComponent,
    WatchComponent,
    AndroidComponent,
  WebsiteDevelopmentComponent,
   WebDesignComponent,
   WordPressComponent,
   AutomatedComponent,
   EcommerceComponent,
    CMSComponent,
   IOSComponent,
    HybridAppComponent,
    ReactAppComponent,
     MobileAppComponent,
    //  ProductComponent,
    //  BrandingComponent,
  //   EnterpriseComponent,
  //   // SaaSComponent
  //    ProductComponent,
  //    SoftwareMaintenanceComponent,
  //    UIUXDesignComponent,
  //   WireframingComponent,
  //    PrototypingComponent,
  //    UXResearchComponent,
  //    ManualTestingComponent,
  //    AutomatedComponent,
  //    PerformanceComponent,
  //    SecurityComponent,
  //   UserAcceptanceComponent,

    // Widgest Components
    SliderComponent,
    BlogComponent,
    LogoComponent,
    ServicesComponent,
    CollectionComponent
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    SharedModule
  ]
})
export class HomeModule { }
